enum DocumentEvents {
  CURRENCY_UPDATE= 'currency_update',
  REGION_UPDATE= 'region_update',
  INVESTMENT_MODAL_STATUS= 'instrument_modal_status',
  AGGREGATOR_MODAL_STATUS= 'aggregator_modal_status',
  NOTIFICATION_MODAL_STATUS = 'notification_modal_status',
  DCA_MODAL_STATUS =  'DCA_modal_status'
}

function subscribe(eventName: DocumentEvents, listener: EventListenerOrEventListenerObject) {
  document.addEventListener(eventName, listener);
}

function unsubscribe(eventName: DocumentEvents, listener: EventListenerOrEventListenerObject) {
  document.removeEventListener(eventName, listener);
}

function publish(eventName: DocumentEvents, data: any) {
  const event = new CustomEvent(eventName, { detail: data });
  document.dispatchEvent(event);
}

export { publish, subscribe, unsubscribe, DocumentEvents };
